import { type ReactElement } from 'react';
import Input from '@creditflowresearch/uilib/Input';
import Checkbox from '@creditflowresearch/uilib/Checkbox';
import Flex from '@creditflowresearch/uilib/Flex';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import useTenor from './useTenor';
import CallableTranches from './CallableTranches';
import PerpetualTranches from './PerpetualTranches';
import {
  FilterSectionIds,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';

import styles from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/rangeFilter.module.scss';

const Tenor = (): ReactElement => {
  const {
    minValue,
    maxValue,
    minMeta,
    maxMeta,
    handleMinChange,
    handleMaxChange,
    isExcluded,
    onToggleExclude,
  } = useTenor();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Tenor }
      header={ (
        <FilterSectionHeader
          title="TENOR AT ISSUE (YEARS)"
          rightSlot={ (
            <Checkbox
              checked={ isExcluded }
              onChange={ onToggleExclude }
              dataTest="tenorExcludedCheckbox"
              label="Exclude selected tenor range"
            />
          ) }
        />
      ) }
      dataTest="tenorSection"
    >
      <Flex align="center" gap={ 8 }>
        { /* @ts-ignore */ }
        <Input
          name="tenorMin"
          type="text"
          placeholder="Min"
          value={ minValue }
          onChange={ handleMinChange }
          meta={ minMeta }
          formFieldClassName={ styles.field }
          inputClassName={ styles.input }
          dataTest="filterMinInput"
          isNarrow
          isClearable={ false }
        />
        <span className={ styles.separator }>-</span>
        { /* @ts-ignore */ }
        <Input
          name="tenorMax"
          type="text"
          placeholder="Max"
          value={ maxValue }
          onChange={ handleMaxChange }
          meta={ maxMeta }
          formFieldClassName={ styles.field }
          inputClassName={ styles.input }
          dataTest="filterMaxInput"
          isNarrow
          isClearable={ false }
        />
      </Flex>
      <Flex gap={ 50 }>
        <CallableTranches />
        <PerpetualTranches />
      </Flex>
    </FilterSection>
  );
};

export default Tenor;
